import { GameConfig} from './GameConfig.ts';
import { SceneHelper } from './utils/SceneHelper.js';
import { Button } from './controls/buttons/Button.js';
import { Panel } from './controls/Panel.js';

export class AboutScene extends Phaser.Scene {
    private scrollPanel!: Panel; // Phaser.GameObjects.Container;

    constructor() {
        super({ key: 'AboutScene' });
    }
    
    preload() {
        this.load.image('arrow-left', 'assets/icons/left.svg');
        this.load.image('code', 'assets/images/code.png');
        this.load.image(GameConfig.icons.back.key, GameConfig.icons.back.path);
    }

    create() {
        // 半透明背景
        //this.add.rectangle(
        //    0, 0,
        //    this.cameras.main.width, this.cameras.main.height, // window.innerWidth, window.innerHeight,
        //    0x000000, 0.9
        //).setOrigin(0, 0);
        SceneHelper.setBgColor(this, 0x000000);
        
        // 返回按钮
        new Button(this, 30, 30, '', { width: 40, height: 40, radius:20, bgColor: GameConfig.colors.primary })
            .setIcon(GameConfig.icons.back.key, 18)
            .setAnimate()
            .onClick(() => SceneHelper.goScene(this, 'WelcomeScene'))
            ;

        // 标题
        this.add.text(
            this.cameras.main.width/2,
            30,
            '关于',
            {
                color: '#ffff00',
                fontSize: 28,
                fontStyle: 'bold',
                fontFamily: GameConfig.fonts.title,
                shadow: {
                    offsetX: 2,
                    offsetY: 2,
                    color: '#000000',
                    blur: 4,
                    fill: true
                }
            }
        ).setOrigin(0.5, 0);

        // 内容
        this.scrollPanel = new Panel(this, 0, 100, this.game.canvas.width, this.game.canvas.height, this.game.canvas.height*2.5, 0, 0x000000);
        var txt = this.add.text(
            this.cameras.main.width/2,
            50,
            [
                'Planets',
                '版本：1.0.0',
                '',
                '作者：程建和',
                '联系：微信 surfsky',
                '版权所有 © 2025',
                '多星球轨道运行模拟游戏',
                `
                游戏使用了Phaser 3框架，
                使用了TypeScript进行开发。

                星球运行遵循牛顿力学定律，万有引力定律，
                速度、加速度、距离等物理量的计算。
                游戏中的星球可以相互作用，
                形成复杂的运动轨迹。
                其基本公式为：

                位移：    p = v * t
                位置：    p2 = p1 + v * dt
                加速度：  a = F / m
                速度：    v2 = v1 + a * dt
                动量：    p = mv
                动量守恒: p1 + p2 = p1' + p2'
                万有引力: F = G * m1 * m2 / (r ^ 2)

                玩家可以通过调整星球的质量、位置等参数，
                来观察不同的运动效果。
                可以实现地月系统、太阳系、双星系统、三体系统等复杂系统。
                可以了解太空中无摩擦力、星球之间依赖万有引力的运动规律。
                了解天体运动的相对坐标系、引力弹弓等原理。
                `
            ].join('\n'),
            {
                fontSize: 18,
                color: '#ffffff',
                fontFamily: GameConfig.fonts.default,
                align: 'center',
                lineSpacing: 14,
                wordWrap: {
                    width: this.cameras.main.width - 40,
                    useAdvancedWrap: true
                },
                padding: {
                    x: 20,
                    y: 20
                }
            }
        ).setOrigin(0.5, 0);
        this.scrollPanel.add([txt]);
        this.scrollPanel.resetContentHeight();

    }
}
